// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { BaseSecurityPageModule } from './app.module';
bootstrapAppModule(BaseSecurityPageModule);
